var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.95752C8.13 2.95752 5 6.08752 5 9.95752C5 15.2075 12 22.9575 12 22.9575C12 22.9575 19 15.2075 19 9.95752C19 6.08752 15.87 2.95752 12 2.95752ZM12 12.4575C10.62 12.4575 9.5 11.3375 9.5 9.95752C9.5 8.57752 10.62 7.45752 12 7.45752C13.38 7.45752 14.5 8.57752 14.5 9.95752C14.5 11.3375 13.38 12.4575 12 12.4575Z",
    fill: "#424B5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_17205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 14,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.95752C8.13 2.95752 5 6.08752 5 9.95752C5 15.2075 12 22.9575 12 22.9575C12 22.9575 19 15.2075 19 9.95752C19 6.08752 15.87 2.95752 12 2.95752ZM12 12.4575C10.62 12.4575 9.5 11.3375 9.5 9.95752C9.5 8.57752 10.62 7.45752 12 7.45752C13.38 7.45752 14.5 8.57752 14.5 9.95752C14.5 11.3375 13.38 12.4575 12 12.4575Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_17205)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.95752,
    width: 24,
    height: 24,
    fill: "#424B5A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.4f80ae9412e1ad319a0e013dfe17ca74.svg";
export { ForwardRef as ReactComponent };